import { TranslationService } from "@/core/services/TranslationService";
import EmailDetail from "@/views/email/views/EmailDetail.vue";
import EmailConfig from "@/views/email/views/EmailConfig.vue";
export function emailTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.name"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.email.provider"),
      key: "emailProviderCodeText",
      sortable: false,
    },
    {
      name: TranslationService.translate("pages.email.hostName"),
      key: "hostName",
      sortable: false,
    },
    {
      name: TranslationService.translate("pages.email.portNumber"),
      key: "portNo",
    },

    {
      name: TranslationService.translate("common.email"),
      key: "email",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function emailTableFilters() {
  return [
    // {
    //   key: "emailIds",
    //   label: TranslationService.translate("common.email"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "notification/filter/EMAIL",
    //   textKey: "text",
    //   valueKey: "value",
    // },
    // {
    //   key: "hostNameIds",
    //   label: TranslationService.translate("pages.email.hostName"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "notification/filter/HOST_NAME",
    //   textKey: "text",
    //   valueKey: "value",
    // },

    {
      key: "emailConfigIds",
      label: TranslationService.translate("common.name"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "notification/filter/EMAIL_CONFIG",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "emailProvider",
      label: TranslationService.translate("pages.email.provider"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKEmailProvider",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    // {
    //   key: "type",
    //   label: TranslationService.translate("pages.email.type"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKEmailConfigType",
    //   textKey: "text",
    //   valueKey: "value",
    // },
  ];
}

export function emailTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "emails",
    entityLabel: TranslationService.translate("bulkDelete.emails"),
  };
}

export function EMAIL_TABS() {
  return [
    {
      title: TranslationService.translate("common.detail"),
      name: "email.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: EmailDetail,
      props: {
        data: {},
      },
    },
    // {
    //   title: TranslationService.translate("pages.email.emailConfig.title"),
    //   name: "email.config",
    //   icon: "bi bi-tools me-2 fs-4 text-primary",
    //   component: EmailConfig,
    //   props: {
    //     data: {},
    //   },
    // },
  ];
}

export function emailConfigTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.type"),
      key: "emailTypeCodeText",
      sortable: true,
      sortingField: "emailType",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function emailConfigTableFilters() {
  return [
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function emailConfigTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "eventConfigs",
    entityLabel: TranslationService.translate("bulkDelete.emails"),
  };
}
